import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { getFilterBrands } from 'store/ProductCatalog/filters/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const Brand = ({ children, url }) => (
  <span className={cx('component')}>
    <a href={url}>{children}</a>
  </span>
);

Brand.propTypes = {
  children: PropTypes.node,
  url: PropTypes.string,
};

export const BrandsLayout = ({ list }) => (
  <div className={cx('container')}>
    <div className={cx('heading')}>Производители</div>
    <div className={cx('content')}>
      {list.map(({ name, url }) => (
        <Brand key={name} url={url}>
          {name}
        </Brand>
      ))}
    </div>
  </div>
);

BrandsLayout.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

export const mapStateToProps = (state) => ({
  list: getFilterBrands(state),
});

export default connect(mapStateToProps)(BrandsLayout);
